<template>
        <!-- unregistered state -->
        <LcForm
            :formData="this.formData.unregistered"
            :formSettings="this.formSettings"
            v-model:application-settings="this.applicationSettings"
            @completed.once="this.completedUnegisteredState()"
        />
</template>

<script>

import LcForm from '@/components/form/LcForm.vue';

import formSteps from '@/form/steps/registration.js';
import formStepsRegistered from '@/form/steps/registered.js';
import formStepsUnregistered from '@/form/steps/unregistered.js';

export default {
    name: 'RegistrationFlowForMembers',
    emits: ["update:application-settings","update:component-settings"],
    components: {
        LcForm,
    },
    props: {
        applicationSettings: {
            type: Object,
            required: true,
        },
        componentSettings: {
            type: Object,
            required: true,
        },
    },
    data: () => {
        // different form steps for different scenarios, check out the imports for this component
        const formData = {
            initial: {
                steps: formSteps
            },
            registered: {
                steps: formStepsRegistered
            },
            unregistered: {
                steps: formStepsUnregistered
            },
        };

        const formSettings = {
            submitButtonText: 'Submit'
        };

        return {
            formData,
            formSettings,
        };
    },
    methods: {
        completedUnegisteredState() {
            this.isUserRegistered = false;
            this.componentSettings.isCompleted = true;
            this.applicationSettings.isUserAuthenticated = false;
        }
    },
    computed: {
        isComponentVisible() {
            return !!this.componentSettings.isVisible; 
        },
    },
    created() {
        // console.log('RegistrationFlow created');
    },
    mounted() {
        // console.log('RegistrationFlow mounted')
    },
    watch: {
    }  

};
</script>